import { useEffect, useState } from 'react'
import "./styles.css"
import { Carousel, Switcher } from '../../Components/Atoms'
import { FEATRUE_INTRO_IMAGES, AJJAS_APP_THEMES } from '../../Library/constants';
import { ArrowRightIcon } from '../../Assets/images/svgs';

const AjjasFeatureIntro = () => {
  const [featureData, setFeatureData] = useState({});
  const [selectedTab, setSelectedTab] = useState(0);
  const [tabOptions, setTabOptions] = useState([]);
  const [carSlides, setCarSlides] = useState([]);
  const [statusBarHeight, setStatusBarHeight] = useState(36);

  const searchParams = new URLSearchParams(window.location.search);
  const themeName = searchParams.get("themeName");

  useEffect(() => {
    const statusHeight = searchParams.get("statusBarHeight");
    if (statusHeight) setStatusBarHeight(statusHeight);

    if (themeName === AJJAS_APP_THEMES.AMBER) document.body.classList.remove("Web-View-Light");
    else {
      window.localStorage.setItem("theme", "light");
      document.body.classList.add("Web-View-Light");
    }

    if (window.data && Object.keys(window.data).length) {
      setFeatureData(window.data);

      if (window.data.tab) {
        const options = window.data?.introData?.tabs?.map(({idx, tabTitle}) => ({idx, label: tabTitle }));
        setTabOptions(options);
      }

      if (window.data.id && themeName) {
        const images = FEATRUE_INTRO_IMAGES[window.data.id]?.(themeName) || [];
        const slides = images.map((img, i) => ({ idx: i + 1, img }));
        setCarSlides(slides);
      }
    }
  }, []);

  const handleTabSwitch = (tab) => {
    if (tab.idx === selectedTab) return;
    setSelectedTab(tab.idx);
  }

  const handleBackPress = () => {
    if (window.ReactNativeWebView) window.ReactNativeWebView.postMessage(JSON.stringify({ action: "go-back" }));
  }

  const handleGoToFeaturePress = () => {
    if (window.ReactNativeWebView) window.ReactNativeWebView.postMessage(JSON.stringify({ action: "navto-feature", data: { feat: featureData.introData.navTo, id: featureData.id } }));
  }

  const getCarSlides = () => {
    var slides = [...carSlides];
    if (featureData.id === "a3") {
      if (selectedTab === 0) slides = slides.slice(0, 2);
      else slides = slides.slice(2, 5);
    }
    return slides;
  }

  const getFeatInfoBody = (data = {}) => {
    const title = data.title;
    const info = data.introData?.info ? data.introData.info : data.info ? data.info : "";
    const subInfo = data.introData?.subInfo ? data.introData.subInfo : data.subInfo ? data.subInfo : "";
    const points = data.introData?.points ? data.introData.points : data.points ? data.points : "";

    return (
      <div className="fa-dets-cnt">
        <p className="fa-dets-title">✨ Here's how {title} helps</p>
        {info ? <p className="fa-dets-des">{info} <span className="fa-dets-subdes">{subInfo}</span> </p> : null}
        {points ? (
          <div className="fa-dets-points">
            {points.map((point, i) => (
              <div className="fa-dets-point" key={i}>
                <div className="fa-dets-bullet" />
                <span className="fa-dets-des">{point}</span>
              </div>
            ))}
          </div>
        ) : null}
      </div>
    );
  }

  return (
    <div className="fa-body">
      <div className="fa-header" style={{ "--statusBarHeight": `${statusBarHeight}px` }}>
        <ArrowRightIcon className="fa-header-back-icon" onClick={handleBackPress}/>
        <p className="fa-header-text">{`${featureData.title} Intro`}</p>
      </div>

      <div className="fa-fixed-content">
        {(tabOptions && tabOptions.length) ? <div className="fa-switcher-cnt">
          <Switcher options={tabOptions} className="fa-switcher" selectedOption={selectedTab} handleChange={handleTabSwitch} />
        </div> : null}

        <div className="fa-carousel-cnt">
          <Carousel slides={getCarSlides()} className="fa-carousel" theme={themeName}/>
        </div>
      </div>

      <div className="fa-scrollable-content">
        {
          featureData?.tab && featureData?.introData?.tabs ? getFeatInfoBody(featureData.introData.tabs.find(tab => tab.idx === selectedTab)) : getFeatInfoBody(featureData)
        }
      </div>

      <div className="fa-goto-btn-cnt">
        <button className="fa-goto-btn cs-btn-gradient" onClick={handleGoToFeaturePress}>Go to {featureData.title}</button>
      </div>
    </div>
  )
}

export default AjjasFeatureIntro